import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant, hasRole } from "@/js/http/auth.js";
import { listCurrencies, listTerms } from "@/js/lists.ts";
import { getErrorData } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import FactoringProviderDialog from "@/components/factoringprovider/FactoringProviderDialog.vue";
export default {
  name: "factoringProviderList",
  components: {
    Confirm: Confirm,
    FactoringProviderDialog: FactoringProviderDialog
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      isLoadingData: true,
      headers: [{
        text: "Name",
        value: "name",
        align: "left"
      }, {
        text: "Delay allowed for payment",
        value: "daysOfDelayAllowed",
        align: "center"
      }, {
        text: "Overwrite due date term",
        value: "termName",
        align: "center"
      }, {
        text: "Currencies",
        value: "label_currencies",
        align: "center"
      }, {
        text: "Available for",
        value: "customer_types",
        align: "center"
      }, {
        text: "Status",
        value: "deleted",
        align: "center",
        width: "120px"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      items: [],
      fetchFactoringProvidersToken: null,
      factoringProviderDialogShown: false,
      factoringProviderIdEdited: 0,
      listTerms: listTerms
    };
  },
  computed: {
    canManageFactoringProviders: function canManageFactoringProviders() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageFactoringProviders;
    },
    getCurrencies: function getCurrencies() {
      return listCurrencies.filter(function (x) {
        return x.implanted_market;
      });
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAuthorized) {
              _context.next = 3;
              break;
            }
            _this2.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this2.fetchFactoringProviders();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchFactoringProviders: function fetchFactoringProviders() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchFactoring;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingData = true;
              (_this3$fetchFactoring = _this3.fetchFactoringProvidersToken) === null || _this3$fetchFactoring === void 0 || _this3$fetchFactoring.cancel();
              _this3.fetchFactoringProvidersToken = axios.CancelToken.source();
              _this = _this3;
              data = {
                withAvailabilities: true,
                includeDeleted: true
              };
              _context2.next = 7;
              return request("/v1/factoring-providers/all", "post", data, true, "api", null, _this3.fetchFactoringProvidersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load financing options.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 7:
              response = _context2.sent;
              _this3.items = response.data.value.items;
              _this3.items.map(function (item) {
                item.disable = false;
                item.label_currencies = _this.mapCurrencies(item.currencies);
                item.customer_types = _this.mapCustomerTypes(item);
                item.termName = item.termId ? _this.listTerms.find(function (x) {
                  return x.id == item.termId;
                }).name : "No";
              });
              _this3.isLoadingData = false;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    mapCurrencies: function mapCurrencies(currencies) {
      var _this4 = this;
      return currencies.map(function (currency) {
        return _this4.getCurrencies.find(function (x) {
          return x.id == currency;
        }).name;
      }).join(", ");
    },
    mapCustomerTypes: function mapCustomerTypes(item) {
      var customerTypes = [];
      if (item.isProfessional) customerTypes.push("Professionals");
      if (item.isWholesaler) customerTypes.push("Wholesalers");
      if (item.isImporter) customerTypes.push("Importers");
      if (item.isIndividual) customerTypes.push("Individuals");
      return customerTypes.join(", ");
    },
    editFactoringProvider: function editFactoringProvider(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.factoringProviderIdEdited = item.id;
              _this5.factoringProviderDialogShown = true;
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    deleteFactoringProvider: function deleteFactoringProvider(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.$refs.confirm.open("Confirm", "Are you sure you want to deactivate this financing option ?<br/><b>The links with users will be removed.</b>", {
                isHtmlMessage: true
              });
            case 2:
              confirmed = _context4.sent;
              if (!confirmed) {
                _context4.next = 10;
                break;
              }
              _this = _this6;
              item.disable = true;
              _context4.next = 8;
              return request("/v1/factoring-provider/".concat(item.id), "delete", null, true, "api", null).catch(function (e) {
                _this.$EventBus.$emit("loading", false);
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete financing option.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 8:
              item.disable = false;
              _this6.fetchFactoringProviders();
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    activateFactoringProvider: function activateFactoringProvider(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.$refs.confirm.open("Confirm", "Are you sure you want to activate this financing option?", {
                color: "red"
              });
            case 2:
              confirmed = _context5.sent;
              if (!confirmed) {
                _context5.next = 10;
                break;
              }
              _this7.$EventBus.$emit("loading", true);
              _this = _this7;
              _context5.next = 8;
              return request("/v1/factoring-provider/".concat(item.id), "put", null, true, "api", null).catch(function (e) {
                _this.$EventBus.$emit("loading", false);
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 8:
              _this7.$EventBus.$emit("loading", false);
              _this7.fetchFactoringProviders();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};